var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 9,
    viewBox: "0 0 15 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3536 4.85355C14.5488 4.65829 14.5488 4.34171 14.3536 4.14645L11.1716 0.964465C10.9763 0.769203 10.6597 0.769203 10.4645 0.964465C10.2692 1.15973 10.2692 1.47631 10.4645 1.67157L13.2929 4.5L10.4645 7.32843C10.2692 7.52369 10.2692 7.84027 10.4645 8.03553C10.6597 8.2308 10.9763 8.2308 11.1716 8.03553L14.3536 4.85355ZM4.37114e-08 5L14 5L14 4L-4.37114e-08 4L4.37114e-08 5Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBlack);
export default __webpack_public_path__ + "static/media/arrow-black.f10daad44b84d385e93dbf1967510ccd.svg";
export { ForwardRef as ReactComponent };